import { useEffect, useState } from "react";

import { BrebReceivingKeyService } from "@/shared/services/payments/brebReceivingKey.service";

/** Whether this staff member may assign custom Bre-B keys. A failed read hides the action, nothing else. */
export function useBrebCustomKeyAccess(): boolean {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    BrebReceivingKeyService.getCustomAccess().then(
      (value) => {
        if (!cancelled) setAllowed(value);
      },
      () => undefined,
    );
    return () => {
      cancelled = true;
    };
  }, []);

  return allowed;
}
